// extracted by mini-css-extract-plugin
export default {"columnsContainer":"columnsContainer__2uyED","cellSummary":"cellSummary__3_PoL","orderSummaryHeader":"orderSummaryHeader__1YBbh","orderSummaryHeaderTitle":"orderSummaryHeaderTitle__2Yxq_","orderSummaryHeaderSubtitle":"orderSummaryHeaderSubtitle__37jqr","bookingsList":"bookingsList__Kz73c","cellBasket":"cellBasket__2LIL2","basketCard":"basketCard__1EOh3","basketCardContent":"basketCardContent__1wEWo","backToShop":"backToShop__3Bq7h"};
    if(module.hot) {
      // 1790586286513
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  